export const DataQuery = `
query ($websiteId: String) {
  websites {
    id
    name
    isProduction
  }
  website(id: $websiteId) {
    id
    name
    isProduction
    pages {
      id
      path
      typeName
      isDraft
      category
      slug
      migration
      creationDate
      tags
      indexable
      matchPath
      analyticsName
      analyticsType
      meta {
       id
       title
       description
       language
      }
      properties {
       id     
       type
       data
       language
      }
      blocks {
        id
        order
        contentType
        variant
        content
        campaignId
        hideForCampaign
        analyticsName
      }
    }
   
    
  
   customBlocks {
    id
    description
    content {
      id
      culture
      data
    }
   }
  }
  
  campaigns {
     id
     name
     start
     stop
     isDraft
     disabled
   }
  
  advertisementGroups {
    id
    name   
    isDraft
    disabled
  }
  
  advertisements {
    id
    description
    content {
      id
      culture
      data
    }
    groups    
    isDraft
    disabled
    filters
  }
   
  pageContent {
    key
    type
    text
    filters
    language
  }
  
  configuration
  contentTypeDefinitions {
    name
    fields {
      name
      type
      label
      description
    }
  }
  dealershipGroups {
    name
    key
    externalReference
  }
  dealerships {
    id
    name
    reference
  }
  dealershipLocationTypes {
    id
    name
  }
  dealerMakes {
    key
    name
    models {
      name
      key
    }
  }
  bodyTypes {
    key
    description
  }
  fuels {
    key
    description
  }
  gearboxes {
    key
    description
  }
  categories {
    key
    description
  }
  labels {
    key
    description
  }
  features {
    key
    description
  }
  exteriorColors {
    key
    description
    colorCode
  }
  interiorColors {
    key
    description
    colorCode
  }
  interiorUpholsteries {
    key
    description
  }
  euroNorms {
    key
    description
  }
  
  tags {
    key
    description
  } 
}
`;

export const PreviewPageQuery = `
query ($data: PreviewPageWebsiteInputType!) {
configuration
  previewPageWebsite(data: $data) {
    id
    name
    isProduction
    pages {
      id
      path
      url
      typeName
      isDraft
      category
      slug
      migration
      creationDate
      tags
      indexable
      matchPath
      analyticsName
      analyticsType
      meta {
       id
       title
       description
       language
      }
      properties {
       id     
       type
       data
       language
      }
      blocks {
        id
        order
        contentType
        variant
        content
        campaignId
        hideForCampaign
        analyticsName
      }
    }
   
    
  
   customBlocks {
    id
    description
    content {
      id
      culture
      data
    }
   }
  }
  
          faqCategories {
            id
            title
            slug
            image
            priority
            url
          }
          faqQuestionGroups {
            id
            title
            categoryId
            priority
          }
          faqQuestions {
            id
            title
            answer {
              culture
              data
            }
            count
            groupId
            priority
          }
          faqTopics {
            id
            title
            slug
            url
            content {
              culture
              data
            }
            priority
            categoryIds
          }
          pageTypes {
            name
            path
            matchPath
            isTemplate
          }
          dealershipGroups {
            name
            key
            reference
            externalReference
            content
          }
          vehicleSearchFilters {
            name
            url
            type
            lng
          }
          seoRoutes {
            path
            pageSeoId
            pageId
            params {
              make
              makeKey
              model
              modelKey
              fuelKey
              gearboxKey
              categoryKey
            }
          }
          pageSeos {
            id
            key
            filters
            metaTitle
            metaDescription
            page {
              id
            }
            content {
              id
              culture
              data
            }
          }
          categories {
            key
            data
          }
          fuels {
            key
            data
          }
          gearboxes {
            key
            data
          }
        
}
`;

export const DealershipTypeTypesQuery = `{
    dealershipLocationTypes {
        id
        name
        description
      }
}`;

export const DealershipQuery = `query ($id: Int!) { 
        dealership(id: $id) { 
            id
            name
            address
            postal
            city
            reference
            email
            facebook
            twitter
            instagram
            linkedin
            fax
            tel 
            url
            image
            openingsHours {
                uuid
                day
                start
                stop
                type {
                  id
                  name
                  description
                }
            }
            closingDays {
                uuid
                start
                stop
                description
                type {
                  id
                  name
                  description
                }
            } 
        }
    }`;

export const DealershipsQuery = `{
  dealerships {
    id
    name
    address
    postal
    city
    reference
    facebook
    twitter
    instagram
    linkedin
    email
    fax
    tel 
    url
    image
    openingsHours {
        uuid
        day
        start
        stop
        type {
          id
          name
          description
        }
    }
    closingDays {
        uuid
        start
        stop
        description
        type {
           id
           name
           description
        }
    }
  }    
}`;

export const ConfigurationQuery = `{
    configuration   
}`;

export const DealershipUpdateMutation = `mutation DealershipUpdate($data: DealershipInputType!) { 
        dealershipUpdate(data: $data) { 
            ok 
            dealership {
                id
                name
                address
                postal
                city
                reference
                facebook
                twitter
                instagram
                linkedin
                email
                fax
                tel 
                url
                image
                openingsHours {
                    uuid
                    day
                    start
                    stop
                    type {
                      id
                      name
                      description
                    }
                }
                closingDays {
                    uuid
                    start
                    stop
                    description
                    type {
                       id
                       name
                       description
                    }
                }
            }
        }
    }`;

export const SiteUpdateMutation = `mutation SiteUpdate($data: SiteInputType!) { 
        siteUpdate(data: $data) { 
            ok 
        }
    }`;

export const MoveDraftToProductionMutation = `mutation WebsiteDraftToProd($data: WebsiteDraftToProdInputType!) { 
    websiteDraftToProd(data: $data) { 
        ok 
    }
}`;

export const SettingsUpdateMutation = `mutation SettingsUpdateV2($data: SettingsUpdateInputType!) { 
        settingsUpdate(data: $data) { 
            ok 
        }
    }`;

export const FileUploadMutation = `mutation FileUpload($file: Upload!) { 
        fileUpload(file: $file) { 
            ok 
            uuid
            location
            url            
        }
    }`;

export const ExecuteMutation = `mutation Execute($action: String!, $project: String!, $payload: JSONString) { 
        execute(action:$action, project:$project, payload: $payload) { 
            ok          
        }
    }`;

export const ConfigurationSettingUpdateMutation = `
    mutation ConfigurationSettingUpdate($value: String!) {
        configurationSettingUpdate(value: $value) {  
            ok            
        }
    }`;
